/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgColoredDatePicker: React.FC<React.SVGAttributes<SVGElement>> = (
    props
) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="currentColor"
                d="M20 4H4c-1.105 0-1 .895-1 2v3h18V6c0-1.105.105-2-1-2z"
                opacity={0.7}
            />
            <path fill="currentColor" d="M3 9h18v12H3z" opacity={0.2} />
            <path
                fill="currentColor"
                d="M16.25 2a.75.75 0 01.75.75V3h4a1 1 0 011 1v17a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h4v-.25a.75.75 0 011.5 0V3h7v-.25a.75.75 0 01.75-.75zm4.316 7.5H3.499l.001 11h17.067l-.001-11zm-12.816 7a.75.75 0 110 1.5.75.75 0 010-1.5zm4.25 0a.75.75 0 110 1.5.75.75 0 010-1.5zm0-4.5a.75.75 0 110 1.5.75.75 0 010-1.5zm4.25 0a.75.75 0 110 1.5.75.75 0 010-1.5zm4.317-7.5H17v.25a.75.75 0 01-1.5 0V4.5h-7v.25a.75.75 0 01-1.5 0V4.5H3.5L3.499 8h17.067V4.5z"
            />
            <path d="M0 0h24v24H0z" />
        </g>
    </svg>
);
